import { authFetch } from "./authFetch";

// Descarga autenticada de un archivo (Excel/PDF/etc.) servido con
// Content-Disposition: attachment. Mismo patrón ya usado en
// HomeDriver.tsx/DriverDeliveries.tsx para /v1/data/driver/print — blob +
// <a> temporal, sin abrir una pestaña nueva ni depender de cookies.
export async function downloadAuthenticatedFile(
  path: string,
  token: string | null,
  fallbackFilename: string
): Promise<void> {
  const response = await authFetch(path, { token });

  if (!response.ok) {
    const text = await response.text().catch(() => "");
    let message = text;
    try {
      const parsed = JSON.parse(text);
      message = parsed?.error || text;
    } catch {
      // no era JSON, se usa el texto tal cual
    }
    throw new Error(message || "No se pudo generar la descarga.");
  }

  const disposition = response.headers.get("Content-Disposition") || "";
  const match = /filename="?([^"; ]+)"?/i.exec(disposition);
  const filename = match?.[1] || fallbackFilename;

  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(objectUrl);
}
